import React, { Children } from 'react';
import { motion } from 'framer-motion';
const services = [{
  title: 'Terapia Individual',
  desc: 'Un espacio personal para explorar tus pensamientos y emociones con guía profesional',
  img: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&q=80'
}, {
  title: 'Terapia de Pareja',
  desc: 'Herramientas para fortalecer la comunicación y reconectar con tu pareja',
  img: 'https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=400&q=80'
}, {
  title: 'Talleres de Mindfulness',
  desc: 'Técnicas de atención plena para reducir el estrés y vivir con mayor presencia',
  img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&q=80'
}, {
  title: 'Orientación para Padres',
  desc: 'Acompañamiento en la crianza consciente y el vínculo con tus hijos',
  img: 'https://images.unsplash.com/photo-1476703993599-0035a21b17a9?w=400&q=80'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: 'easeOut'
    }
  }
};
export function Services() {
  return <section className="py-24 px-6 lg:px-12 max-w-7xl mx-auto" data-id="element-81">
      <motion.div className="text-center mb-16" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} data-id="element-82">
        <h2 className="text-4xl md:text-5xl font-serif text-dark mb-4" data-id="element-83">
          Nuestros Servicios
        </h2>
        <p className="text-medium text-lg max-w-2xl mx-auto" data-id="element-84">
          Enfoques terapéuticos adaptados a tus necesidades específicas.
        </p>
      </motion.div>

      <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} data-id="element-85">
        {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="bg-crema-light rounded-[2rem] overflow-hidden shadow-neumorph flex flex-col h-full transition-all duration-300 hover:-translate-y-2 hover:shadow-neumorph-hover" data-id="element-86">
            <div className="h-48 w-full overflow-hidden p-3 pb-0" data-id="element-87">
              <img src={service.img} alt={service.title} className="w-full h-full object-cover rounded-t-[1.5rem] rounded-b-xl" data-id="element-88" />
            </div>
            <div className="p-8 flex flex-col flex-grow text-center" data-id="element-89">
              <h3 className="text-2xl font-serif text-dark mb-4" data-id="element-90">
                {service.title}
              </h3>
              <p className="text-medium leading-relaxed flex-grow" data-id="element-91">
                {service.desc}
              </p>
            </div>
          </motion.div>)}
      </motion.div>
    </section>;
}